import React from "react";
import './Activity.css';

import { renderIcon } from "../../utils";

import { Link } from "react-router-dom";



const Activity = ({ activity }) => {

    return (

        <div className="activity-item">

            <img src={activity.image} alt={activity.title} /> {/* Activity Image */}

            <div className="content">

                <div className='icon'>{renderIcon(activity.title)}</div> {/* Display the Activity icon based on title */}

                {/* Link to the individual Activity page */}
                <Link
                    to={{
                        pathname: '/Activities/' + activity.title,  // Navigate to the specific Activity page
                    }}
                    location = {{activity}}  // Passing Activity details to the linked page
                    state= {activity}>
                    <h3>{activity.title}</h3> {/* Activity Title */}
                </Link>

            </div>

        </div>
    );
};

export default Activity;